export const formatVehicle = ({ record, vehicle, expertise, versions }) => {
  const data = { ...vehicle };
  if (vehicle) {
    data.makeId = vehicle?.brandId;
    delete data.brandId;
    data.makeName = vehicle?.brandLabel;
    delete data.brandLabel;
    data.modelName = vehicle?.modelLabel;
    delete data.modelLabel;
    data.dateRelease = vehicle?.registrationDate?.date;
    delete data.registrationDate;
    data.entryDateRelease = vehicle?.entryRegistrationDate?.date;
    delete data.entryRegistrationDate;
    data.dateGrayCard = vehicle?.gcDate?.date;
    delete data.gcDate;
    data.fuelName = vehicle?.fuelLabel;
    delete data.fuelLabel;
    data.bodyName = vehicle?.bodyLabel;
    delete data.bodyLabel;
    data.doors = vehicle?.door;
    data.doorId = vehicle?.door;
    delete data.door;
    data.gearId = vehicle?.gearBoxId;
    data.gearName = vehicle?.gearBoxLabel;
    delete data.gearBoxId;
    delete data.gearBoxLabel;
    data.engineId = vehicle?.ps;
    data.engine = vehicle?.ps;
    delete data.ps;
    data.versions = versions;
    data.profile = record?.profile;
    data.refHexaId = record?.refHexaId;
    data.concessions = expertise?.concessionId;
  }

  if (record?.statusId === 18) {
    data.makeId = null;
    data.makeName = null;
    data.modelId = null;
    data.modelName = null;
    data.dateRelease = null;
    data.entryDateRelease = null;
    data.dateGrayCard = null;
    data.fuelId = null;
    data.fuelName = null;
    data.bodyId = null;
    data.bodyName = null;
    data.doors = null;
    data.doorId = null;
    data.gearId = null;
    data.gearName = null;
    data.engineId = null;
    data.engine = null;
    data.versions = null;
    data.mileage = null;
    data.versionId = null;
    data.versionList = null;
  }
  return data;
};
